var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6655 14V28.3963H23.3041V30.0979L25.3889 29.4185L27.4737 30.0979V28.3963H30V14H11.6655ZM26.3994 28.6179L25.3889 28.2886L24.3784 28.6179V27.3887C24.6905 27.5161 25.0315 27.5869 25.3889 27.5869C25.7463 27.5869 26.0873 27.5161 26.3994 27.3887V28.6179ZM25.3889 26.5127C24.5015 26.5127 23.7796 25.7907 23.7796 24.9033C23.7796 24.016 24.5015 23.294 25.3889 23.294C26.2763 23.294 26.9982 24.016 26.9982 24.9033C26.9982 25.7907 26.2763 26.5127 25.3889 26.5127ZM28.9257 27.322H27.4737V26.5906C27.8478 26.1293 28.0725 25.5421 28.0725 24.9033C28.0725 23.4236 26.8687 22.2197 25.3889 22.2197C23.9092 22.2197 22.7053 23.4236 22.7053 24.9033C22.7053 25.5421 22.9301 26.1293 23.3042 26.5906V27.322H12.7398V15.0743H28.9257V27.322Z",
    fill: "#033476"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7772 16.9404H14.8884V18.0147H26.7772V16.9404Z",
    fill: "#033476"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7772 19.4416H14.8884V20.5159H26.7772V19.4416Z",
    fill: "#033476"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8328 21.9429H14.8884V23.0172H20.8328V21.9429Z",
    fill: "#033476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon11.fec8d55171609f190ddeb251dae7cb51.svg";
export { ForwardRef as ReactComponent };